<template>
  <aside :class="['clothing__bar', { '--opened': isOpen }]">
    <ClothingToggleButton @click="isOpen = !isOpen" />
    <ClothingType :active-type="selectedType" />
    <div class="clothing__type-list">
      <Icon
        id="clothing_selection"
        class="clothing__type-active"
        :style="`--left-translation: ${(activeIndex * 57) / 16}rem`"
      />
      <button
        v-for="(type, index) in $store.state.clothing.types"
        :key="type"
        :class="['clothing__type', { '--active': type === selectedType }]"
        @click="updateSelectedType(type, index)"
      >
        <Icon :id="`clothing_type_${type}`" />
      </button>
    </div>
  </aside>
</template>

<script>
import ClothingType from '@/components/clothing/ClothingType.vue'
import { Icon } from '@/components/global'
import { ClothingToggleButton } from '@/components/small'

export default {
  name: 'ClothingBar',
  data() {
    return {
      activeIndex: 1,
      isOpen: false,
      selectedType: 'hair',
    }
  },
  components: { ClothingToggleButton, ClothingType, Icon },
  mounted() {
    setTimeout(this.init, 400)
  },
  methods: {
    init() {
      this.isOpen = true
    },
    updateSelectedType(type, index) {
      this.selectedType = type
      this.activeIndex = index
    },
  },
}
</script>
